import Vue from 'vue'


//防重复点击 v-preventReClick
const preventReClick = Vue.directive('preventReClick', {
    inserted: function (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true;
                const _i = document.createElement('i');
                _i.setAttribute('class','el-icon-loading');
                el.insertBefore(_i,el.children[0]);
                el.classList.add('is-loading');
                setTimeout(() => {
                    el.disabled = false;
                    el.removeChild(el.children[0]);
                    el.classList.remove('is-loading');
                }, binding.value || 3000)
            }
        })
    }
});

/*const loading_test = Vue.directive('xiao_loading',{

})*/


export  { preventReClick }



// WEBPACK FOOTER //
// ./src/assets/js/preventReClick.js